export const i18nCasePage = {
  analytics: {
    cases: 'Casos',
    cases_by_stage: 'Casos por etapa',
    actions: 'Ações',
    pieChartSelect: {
      actions: {
        type_case_action: 'Ações por tipo',
        status: 'Ações por estado',
      },
      cases: {
        dimension: 'Dimensão',
        discipline: 'Disciplina',
        detectionMethod: 'Método de Detecção',
      },
    },
  },
  goToStageBanner: {
    message: 'Deseja alterar o estágio para {{stage}}?',
    not_permitted: 'Para mudar para o estágio {{stage}}, todas as ações devem ser executadas.',
  },
  goToStage: {
    title: 'Deseja alterar o estágio para {{stage}}?',
    message:
      'Para criar uma nova ação, você deve deixar o estágio {{currentStage}} e ir para {{stage}}.',
    no: 'Não, fique em {{currentStage}}',
    yes: 'Sim, vá para {{stage}}',
  },
  ableToOperate: {
    tag: {
      active: 'Capaz de operar',
      inactive: 'Incapaz de operar',
    },
    modal: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      label: 'O ativo pode operar?',
      description:
        'Se o ativo for definido como “Não pode operar”, um alarme será acionado quando ele for ligado. Você também pode alterar o status operacional na página do ativo.',
      title: 'Status operacional do ativo',
    },
    options: {
      yes: 'Capaz de operar',
      no: 'Incapaz de operar',
    },
  },
  externalReference: {
    title: 'Referências Externa',
    tooltip: {
      plural: '{{value}} ações ',
      singular: '{{value}} ação ',
    },
    not_found: 'Não encontrada',
    'open-critical': 'Aberto crítico',
    'open-non-critical': 'Aberto não crítico',
    closed: 'Fechado',
  },
  related: {
    table: {
      title: 'Adicionar alarme relacionado ao equipamento',
    },
    addEdit: 'Adicionar/Editar',
  },
  table: {
    agreg: '#',
    alarm_datetime_start: 'Início',
    asset: 'Equipamento',
    is_assigned_to_case: '',
    classification: 'Classific.',
    delete: '',
    description: 'Nome',
    id: 'ID',
    link: '',
    name: 'Título',
    notif: '',
    records: 'Registros',
    severity: 'Sever.',
    status: 'Etapa',
    is_automatic: 'Auto Rec.',
    new_alarms: 'New',
    is_automatic_tooltip:
      'Novos alarmes do mesmo modelo serão automaticamente reconhecidos como úteis e anexados a esse case enquanto ele estiver aberto.',
    is_automatic_blocked_tooltip:
      'Este alarme não pode ser marcado como automático porque já está vinculado a outro case.',
  },
  buttons: {
    edit: 'Editar / Abrir completo',
    evidences: 'Evidências ({{quantity}})',
    records: 'Registros ({{quantity}})',
    relatedEvents: 'Eventos Relacionados ({{quantity}})',
    newAction: 'Nova ação',
    newCase: 'Novo caso',
    casesPage: 'Pág. de Casos',
    expandCase: 'Expandir caso',
  },
  filters: {
    allCategories: 'Todas categ. de ativos',
    allOwners: 'Todos os Proprietários',
    search: 'Pesquisar',
  },
  title: {
    actions: 'Ações ({{quantity}})',
    cases: 'Casos',
    diagnosis: 'Diagnóstico',
    diagnosisValidation: 'Validação do Diagnóstico',
    feedback: 'Feedback',
    closed: 'Fechado',
    externalReference: 'Referência Externa',
  },
  status: {
    diagnosis: 'Diagnóstico',
    actions: 'Ações',
    execution: 'Execução',
    on_hold: 'Em Espera',
    canceled: 'Canceled',
    feedback: 'Feedback',
    closed: 'Fechado',
  },
  inputs: {
    dimension: 'Dimensão',
    discipline: 'Disciplina',
    severity: 'Severidade',
    anomaly_start: 'Início da Anomalia',
    anomaly_end: 'Fim da Anomalia',
    diagnosis: 'Diagnóstico',
    team_a_review: 'Revisão da Equipe A',
    team_b_review: 'Revisão da Equipe B',
    asset: 'Equipamento',
    detection_method: 'Método de Detecção',
    // Action
    type: 'Tipo',
    maintenanceNotification: 'Notificação de manutenção',
    status: 'Status',
    dueDate: 'Data de vencimento',
    creationDate: 'Data de criação',
    dueDateLabel: 'Data limite',
    executionDateLabel: 'Data de execução',
    dueDateTooltip: 'Quando a data limite for excedida, o status da ação mudará para Atrasado',
    executionDateTooltip: 'Após salvar a data de execução, o status da ação mudará para Executado',
    executionFeedback: 'Feedback de execução',
    details: 'Detalhes',
    is_able_to_operate: 'Capaz de operar',
    equipment_class: 'Classe de equipamento',
    subunit: 'Subunidade',
    failure_mode: 'Modo de falha',
    failure_mechanism: 'Mecanismo de falha',
    total_estimated_cost: 'Custo total estimado (USD)',
    maintainable_item: 'Item manutenível',
    maintenance_scope: 'Escopo de manutenção',
  },
  placeholders: {
    caseTitle: 'Digite o título do caso',
    actionTitle: 'Digite o título',
    awaitingDiagnoseClosure: 'Aguardando fechamento do diagnóstico',
    diagnosis: 'Digite os detalhes do diagnóstico',
    selectAnOption: 'Selecione uma opção',
    selectUser: 'Selecione um usuário',
    selectAsset: 'Selecione um equipamento',
    comments: 'Comentários',
    owner: 'Proprietário: Você',
    availableWithStatus: 'Disponível quando você inserir a data de execução.',
    enterCode: 'Digite o código',
    enterDetails: 'Insira os detalhes',
    enterNotificationNumber: 'Insira o número da notificação',
    pickDate: 'Escolha uma data',
    select: 'Selecione',
    typeText: 'Insira qualquer feedback que você tenha sobre a execução da ação.',
  },
  tooltips: {
    newActionNotAllowed: "Novas ações só podem ser adicionadas no status 'Ações'.",
    enterDetails: 'Insira os detalhes',
    enterNotificationNumber: 'Insira o número da notificação',
    select: 'Selecione',
    typeText: 'Digite aqui',
    no_changes: 'Nenhuma alteração para salvar por enquanto',
  },
  severity: {
    very_high: 'Muito alta',
    high: 'Alta',
    medium: 'Média',
    low: 'Baixa',
    minor: 'Menor',
  },
  dimension: {
    dynamic_condition: 'Condição dinâmica',
    auxiliary_system: 'Sistema auxiliar',
    process_condition: 'Condição do processo',
    oil_analysis: 'Análise de óleo',
  },
  discipline: {
    rotative: 'Rotativo',
    electrical: 'Elétrico',
    instrumentation: 'Instrumentação',
    process: 'Processo',
    automation: 'Automação',
    others: 'Outros',
    EMPTY: 'Vazio',
  },
  conclusion: {
    label: 'Conclusão sobre a anomalia',
    no_issue_found: 'Nenhum problema encontrado',
    solved_completely: 'Resolvido completamente',
    solved_partially: 'Resolvido parcialmente',
    not_solved: 'Não resolvido',
  },
  team_review: {
    rejected: 'Rejeitado',
    accepted: 'Aceito',
  },
  actions: {
    status: {
      on_track: 'No prazo',
      delayed: 'Atrasado',
      executed: 'Executado',
      none: 'Nenhum',
    },
    type_case_action: {
      maintenance: 'Manutenção',
      operations: 'Operações',
    },
  },
  created: 'Criado',
  last_edition_by: 'Última edição: {{updatedAt}} | @{{username}}',
  mandatory_fields: '* Campos obrigatórios para a próxima etapa',
  main_tabs: {
    OPEN: 'Aberto',
    CLOSED: 'Fechado',
    ALL: 'Todos',
  },
  table_tabs: {
    cases: 'Casos',
    actions: 'Ações',
  },
  tabs: {
    evidences: 'Evidências e Docs ({{quantity}})',
    relatedAlarms: 'Alarmes vinculados ({{quantity}})',
    relatedCases: 'Casos vinculados ({{quantity}})',
  },
  status_count_panel: {
    empty_data: 'Não há dados disponíveis para filtrar',
    severity: {
      title: 'Severidade',
      4: 'Muito Alta',
      3: 'Alta',
      2: 'Média',
      1: 'Baixa',
    },
    status: {
      action_status: {
        title: 'Estado da Ação',
        on_track: 'No prazo',
        delayed: 'Atrasado',
        all_executed: 'Todos Executados',
        executed: 'Executado',
        none: 'Nenhum',
      },
      total: { title: 'Total', total: 'Casos' },
      status: {
        title: 'Status',
        OPEN: 'Aberto',
        CLOSED: 'Fechado',
      },
    },
    stage: {
      title: 'Estado',
      actions: 'Ações',
      canceled: 'Canceled',
      closed: 'Fechado',
      diagnosis: 'Diagnóstico',
      feedback: 'Resposta',
      on_hold: 'Em espera',
      none: 'Nenhum',
    },
  },
  common: {
    actions: 'Ações',
    action_status: 'Status da ação',
    anomaly_start: 'Início da anomalia',
    anomaly_end: 'Fim da anomalia',
    asset: 'Equipamento',
    cancel: 'Cancelar',
    category: 'Categoria',
    created: 'Criado',
    description: 'Descrição',
    diagnosis: 'Diagnóstico',
    dimension: 'Dimensão',
    discipline: 'Disciplina',
    event_code: 'ID',
    external_reference: 'Referência Externa',
    external_reference_code: 'Código',
    external_reference_summary: 'Ref. ext.',
    name: 'Título',
    none: 'None',
    owner_mail: 'Proprietário',
    save: 'Salvar',
    severity: 'Severidade',
    start_date: 'Criado',
    status: 'Etapa',
    updated_at: 'Última edição',
    alarms_30_days: 'Alarmes 30d',
    closed_date: 'Fechado',
    preview: 'Pré-visualizar',
  },
  no_data: {
    list: 'Não há casos disponíveis para as configurações filtradas.',
    related_alarms: 'Nenhum alarme relacionado foi adicionado',
    related_alarms_modal: 'Este equipamento não possui alarmes no período selecionado',
    empty_actions: 'Nenhuma ação criada até agora.',
  },
  new: 'Novo',
  new_case: 'Novo Caso',
  new_action: 'Nova Ação',
  expand: 'Expandir lista',
  expand_tutorial_title: 'Apresentando Insights Visuais',
  expand_tutorial_description:
    'Sua lista de casos agora inclui gráficos para insights rápidos. Use "Expandir Lista" para voltar à visualização completa da lista.',
  expand_tutorial_button: 'Entendi',
  show_analytics: 'Mostrar Analytics',
  deleted: 'Excluído',
  cancel: 'Cancelar',
  confirm_delete: 'Sim, exclua',
  continue_anyway: 'Sim, continuar',
  messages: {
    create: {
      title: 'Sucesso!',
      message: 'Novo caso criado com sucesso',
    },
    edit: {
      title: 'Sucesso!',
      message: 'Alterações aplicadas com sucesso!',
    },
    delete: {
      title: 'Excluir ação e perder todos os seus dados?',
      message: 'Esta ação tem informações que serão perdidas. Tem certeza de que deseja continuar?',
    },
    delete_asset: {
      title: 'Os alarmes relacionados serão apagados se você alterar o ativo.',
      message: 'Você tem certeza que quer continuar?',
    },
    attach_exit_without_saving: {
      title: 'Sair da associação de alarme a um caso existente',
      button: {
        primary: 'Sim, sair',
        secondary: 'Não, voltar',
      },
    },
    cancel: {
      title: 'Por que você está cancelando o caso?',
      placeholder: 'Por favor, insira o motivo',
      button: {
        primary: 'Cancelar caso',
        secondary: 'Voltar',
      },
    },
    diagnosis_not_filled: {
      title: 'Por favor, complete todos os campos obrigatórios',
      message:
        'Antes de ir para a etapa Ações, você precisa preencher os campos Título, Ativo e Diagnóstico.',
      button: {
        ok: 'OK',
      },
    },
    diagnosis_to_actions: {
      title: 'Terminar Diagnóstico e ir para Ações?',
      message: 'O diagnóstico será salvo e o estado mudará para Ações, para poder criar ações.',
      button: {
        go_to_actions: 'Sim, ir para Ações',
        cancel: 'Cancelar',
      },
    },
  },
  records: {
    creation_date: 'Data de Criação',
    name: 'Nome da Ação',
    case_name: 'Nome do Caso',
    type_case_action: 'Tipo',
    details: 'Detalhes',
    external_reference: 'Tipo de Referência externa',
    code: 'Código da Referência externa',
    owner_mail: 'Proprietário',
    status: 'Status',
    due_date: 'Data de Vencimento',
    end_date: 'Data de Execução',
    dimension: 'Dimensão',
    severity: 'Severidade',
    low: 'Baixa',
    medium: 'Média',
    high: 'Alta',
    very_high: 'Muito Alta',
    anomaly_start: 'Início da anomalia',
    anomaly_end: 'Fim da anomalia',
    detection_method: 'Método de detecção',
    diagnosis: 'Diagnóstico',
    discipline: 'Disciplina',
    conclusion: 'Conclusão',
    feedback: 'Feedback',
    actions: 'Ações',
    feedback_comments: 'Comentários de feedback',
    feedback_conclusion: 'Conclusão do feedback',
    title: 'Registros',
    add_a_comment: 'Adicionar um comentário',
    view_records: 'Ver registros',
    event_records: 'Registros de eventos',
    attachments: 'Anexos',
    comments: 'Comentários',
    summary: {
      attachments: 'Anexos',
      comments: 'Comentários',
      last_update: 'Última atualização: ',
    },
    category: {
      alarm_created: 'Alarme criado',
      alarm_visualized: 'Alarme visualizado',
      alarm_closed: 'Alarme fechado',
      attached_file: 'Arquivo anexado',
      detached_file: 'Arquivo desanexado',
      comment: 'Comentário',
    },
  },
  evidences: {
    title: 'Evidências e Documentos ({{quantity}})',
    new: 'Novo',
    attach: 'Anexar',
    attached: 'Anexados',
    no_data: 'Nenhum arquivo anexado',
    undo: 'Desfazer',
    drag_file_here: 'Arraste e solte aqui',
    drop_file_here: 'Solte o arquivo aqui',
    search_in_device: 'Buscar em meu dispositivo',
    upload_not_available: 'Upload não disponível neste contexto',
    upload_files_to_continue: 'Envie arquivos para continuar',
    save_attched_files: 'Salvar arquivos anexados',
    messages: {
      exit: {
        title: 'Atenção!',
        message: 'Se você sair sem salvar, essas alterações serão perdidas.',
      },
      repetead: {
        title: 'Desculpe, há arquivos anexados com o mesmo nome',
        message: 'Renomeie o arquivo antes de selecioná-lo.',
      },
      mandatory: {
        title: 'Desculpe, não foi possivel salvar o status.',
        message: 'Preencha todos os campos obrigatórios (com *) antes de alterar o status.',
      },
      tooltip:
        'Formatos de arquivo permitidos: XLS, TXT, PDF, DOC, JPG e PNG com tamanho de até 10 Mb',
      tooltipRevert: 'Desfazer exclusão',
      upload_success: 'Arquivos carregados com sucesso',
      upload_failed: 'Erro ao carregar arquivos, por favor tente novamente.',
      delete_success: 'Arquivo excluído com sucesso',
      delete_error: 'Erro ao excluir o arquivo, por favor tente novamente.',
      some_uploads_failed: 'Falha ao carregar {{count}} arquivos',
    },
    buttons: {
      exit: 'Sair',
      back: 'Voltar',
      ok: 'Ok',
    },
  },
  savings: {
    title: 'Savings',
    has_savings: {
      no: 'Não',
      yes: 'Sim',
    },
  },
  tooltip: {
    asset_title_mandatory: 'Você deve inserir o título do Case e o Equipamento para prosseguir.',
  },
  Cases: {
    openAsset: 'Abrir Ativo',
    newCd: 'Novo CD',
    openNewCD: 'Criar nova Desvio de Condição',
    editCD: 'Editar Desvio de Condição',
    asset: 'Ativo',
    newAsset: 'Selecione um ativo',
    asset_id: 'ID do Ativo',
    dimension: 'Dimensão',
    category: 'Categoria',
    category_id: 'Id da Categoria',
    detection_method: 'Método de Detecção',
    deviation_start: 'Início do desvio',
    deviation_end: 'Fim do desvio',
    duration: 'Duração',
    diagnosis: 'Diagnóstico',
    detailing: 'Detalhamento',
    recommended_action: 'Ações recomendadas',
    actionStatus: 'Status da ação',
    sap_note: 'Nota',
    sapNoteTooltip: 'O campo de Nota é obrigatório com o status de ação “Ação emitida”',
    assetConditionEvaluation: 'Aval. de condição',
    condition_evaluation: 'Aval. de condição',
    assetStatus: 'Status do ativo',
    savings: 'Economias',
    savings_required: 'Economias',
    savingsNoteTooltip: 'Economias é um campo opcional e pode ser preenchido posteriormente',
    description: 'Descrição',
    equipment_class: 'Classe de ativo',
    subunit: 'Subunidade',
    maintainable_item: 'Item manutenível',
    failureMode: 'Modo de falha',
    failure_mechanism: 'Mecanismo de falha',
    maintenance_scope: 'Escopo de manutenção',
    noFillesAttached: 'Nenhum arquivo anexado',
    attachFile: 'Anexar arquivo',
    alarmsLinked: '{{alarmsCount}} Alarmes vinculados',
    toThisCD: 'a esse Desvio de Condição',
    addViewAlarms: 'Adicionar/visualizar alarmes ativos',
    caseOwner: 'Dono:',
    is_out_of_service: 'Equipamento pode operar?',
    outOfServiceOptions: {
      yes: 'Capaz de operar',
      no: 'Incapaz de operar',
    },
    options: {
      tooltip: {
        actions:
          'Por favor, complete todos os campos obrigatórios em Diagnóstico antes de mudar o estado.',
        feedback:
          'As ações devem ter estado “Executado” ou “Cancelado” (salvo) para ir para Feedback.',
        closed:
          'Por favor, complete todos os campos obrigatórios em Feedback antes de mudar para Fechado.',
      },
      action_status: {
        INVESTIGATING: 'Investigando',
        ACTION_ISSUED: 'Ação emitida',
        CANCELED: 'Cancelado',
        UNDER_EVALUATION: 'Em avaliação',
        COMPLETED: 'Concluído',
      },
      condition_evaluation: {
        NORMAL_CONDITION: 'Baixo',
        ALARM_CONDITION: 'Médio',
        CRITICAL_CONDITION: 'Muito Alto',
        POTENTIAL_PROBLEM: 'Alto',
        NOT_MONITORED: 'Não Monitorado',
        NOT_OPERATED: 'Não Operado',
        modec: {
          NORMAL_CONDITION: 'Condição Normal',
          ALARM_CONDITION: 'Condição de Alarme',
          CRITICAL_CONDITION: 'Condição Crítica',
          POTENTIAL_PROBLEM: 'Problema Potencial',
          NOT_MONITORED: 'Não Monitorado',
          NOT_OPERATED: 'Não Operado',
        },
      },

      dimensions: {
        AUXILIARY_SYSTEM: 'Sistema auxiliar',
        PROCESS_CONDITION: 'Condição de processo',
        DYNAMIC_CONDITION: 'Condição dinâmica',
        OIL_ANALYSIS: 'Análise de óleo',
      },
    },
    confirmChangeAsset:
      'Ao alterar o Ativo, os alarmes vinculados serão apagados. Continuar mesmo assim?',
    yesContinue: 'Sim, continuar',
    save: 'Salvar',
    placeholders: {
      assetName: 'Comece a digitar para exibir opções',
      dimension: 'Selecionar dimensão',
      selectAnOption: 'Selecionar uma opção',
      select: 'Selecionar',
      dayHour: 'Escolha dia e hora',
      diagnosis: 'Insira o diagnóstico do desvio',
      detailing: 'Insira detalhes',
      recommendedActions: 'Insira recomendações',
      sapCode: 'Insira a Nota ',
      description: 'Um breve resumo sobre o evento de economia',
    },
    messages: {
      toBeRequired: 'Este campo é obrigatório',
      duplicate_attribute_name: 'Nome de atributo duplicado',
      only_numbers: 'Apenas números',
      confirmTurnOffCannotOperate:
        'Tem certeza de que deseja desativar o status NÃO PODE OPERAR para este equipamento?',
      confirmTurnOnCannotOperate:
        'Tem certeza de que deseja ativar o status NÃO PODE OPERAR para este equipamento?',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    modalTitles: {
      new: 'Abrir novo Desvio de Condição',
      edit: 'Desvio de Condição',
    },
    conditionEvaluation: {
      POTENTIAL_PROBLEM: 'Alto',
      CRITICAL_CONDITION: 'Muito Alto',
      ALARM_CONDITION: 'Médio',
      NORMAL_CONDITION: 'Baixo',
    },
  },
  tableColumns: {
    severity: 'Severidade',
    start_date: 'Criado',
    name: 'Nome',
    dimension: 'Dimensão',
    discipline: 'Disciplina',
    status: 'Estágio',
    action_status: 'Status Ação',
    externalReference: 'Ref. Ext.',
    updated_at: 'Última edição',
  },
  components: {
    casesByAssetTable: {
      name: 'Ativo',
      bar: 'Casos',
      count: '#',
    },
    casesByOwnerTable: {
      owner_mail: 'Proprietário',
      cases: 'Casos',
      number: '#',
      no_data: 'Nenhum dado disponível',
    },
  },
  actions_table: {
    creation_date: 'Criado',
    name: 'Nome',
    case_name: 'Nome do caso',
    type_case_action: 'Tipo',
    details: 'Detalhes',
    external_reference_type: 'Ref. externa',
    external_reference: 'Código',
    owner_mail: 'Dono',
    status: 'Estado',
    due_date: 'vencimento',
  },
  error: {
    noOpenCases: 'Não há casos abertos no período selecionado.',
    noClosedCases: 'Não há casos fechados no período selecionado.',
    noCases: 'Não há casos no período selecionado e os filtros selecionados.',
  },
  assetCases: 'Casos do ativo',
};
